/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { InvoicePaidStatus } from '@msdyn365-commerce/retail-proxy';

export enum InvoiceRefinerSourceType {
    InvoiceNumber = 1,
    InvoiceDate = 2,
    DueDate = 3,
    Status = 4,
    Origin = 5,
    Organization = 6,
    Contact = 7
}

export enum DateRefinerOptionItem {
    LastSevenDays = 0,
    LastThirtyDays = 1,
    LastThreeMonths = 2,
    Customized = 999
}

export enum InvoiceStatusRefinerOptionItem {
    Unpaid = InvoicePaidStatus.Unpaid,
    PartiallyPaid = InvoicePaidStatus.PartiallyPaid,
    Paid = InvoicePaidStatus.Paid
}

export interface IDateRange {
    startDate?: Date;
    endDate?: Date;
}
